











import registerPC from "./patternPC/index.vue";
import registerH5 from "./patternH5/index.vue";
import { setup } from "../../utils/devicePlatform";
import Vue from "vue";
export default {
  name: "aiwen-register",
  data() {
    return {
      platformMes: {
        appVersion: "",
        systemVersion: "",
        platform: "h5",
        device: "browser",
        adapterMobile: false
      }
    };
  },
  components: {
    "register-pc": registerPC,
    "register-h5": registerH5
  },
  created() {
    (this as any).platformMes = setup();
  }
};
